var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('th',[_vm._v(_vm._s(_vm.displayName))]),_c('td',[_vm._v(_vm._s(_vm.selectedLevel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }